import moment from "moment";
import React, {Component,useState} from "react";
import {withTranslation} from "react-i18next";
import ReactTable from "react-table";
import "react-table/react-table.css";
import {searchHistoryLogTier} from "../../api/IrsClient";
import ModalError from "../common/ModalError";
import TierPricingHistorySearchForm from "./TierPricingHistorySearchForm";
import ModalNotFound from "../common/ModalNotFound";
const TEXT_CELL_STYLE = {
  alignContent: "center",
  fontSize: "12px",
};

const initState = {
  data: [],
  page: 0,
  pageSize: 20,
  pages: 1,
  pageNumList: [1],
  pageSizeOptions: [20, 50, 100],
  loading: false,
  showPagination: true,
  cacheRequestBody: null,
  disable: false,
  isOpenModal: false,
  modalMessage: "",
  sessionTimeout: false,
};

class TierPricingHistorySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initState,
      notFound: null,
    };
  }
  componentDidUpdate() {
    if (!this.state.loading && !this.state.showPagination) {
      this.setState({ showPagination: true });
    }
  }

  requestModalCloseHandler = () => {
    this.setState({
      isOpenModal: false,
    });

    if (this.state.sessionTimeout) {
      const { logout } = this.props;
      logout();
    }
  };

  onClear = () => {
    this.setState({
      ...initState,
      showPagination: false,
    });
  };

  onPageChange = (page) => {
    this.setState({
      page: page,
    });

    this.fetchHistoryDataOnChangePage(page, this.state.pageSize);
  };

  onPageSizeChange = (newPageSize, newPage) => {
    this.setState({
      page: newPage,
      pageSize: newPageSize,
    });

    this.fetchHistoryDataOnChangePage(newPage, newPageSize);
  };

  convertDateToString = (dateStr) => {
    let returnedDate = "-";

    if (dateStr && dateStr !== "") {
      returnedDate = moment(dateStr).format("DD/MM/YYYY HH:mm:ss");
    }

    return returnedDate;
  };

  fetchHistoryDataOnChangePage = (page, pageSize) => {
    const requestBody = this.state.cacheRequestBody;

    if (requestBody) {
      requestBody["page_no"] = page + 1;
      requestBody["item_per_page"] = pageSize;

      this.callSearchApi(requestBody);
    } else {
      this.setState({
        page: page,
        pageSize: pageSize,
      });
    }
  };

  fetchHistoryData = (params) => {
    const { branchId, historyStartDate, historyEndDate } = params;

    const startDateStr = moment(historyStartDate).format("YYYY-MM-DD");
    const endDateStr = moment(historyEndDate).format("YYYY-MM-DD");
    const requestBody = {};

    requestBody["start_date"] = startDateStr + "T00:00:00";
    requestBody["end_date"] = endDateStr + "T23:59:59";
    requestBody["branchs"] = branchId.split(",");
    requestBody["page_no"] = 1;
    requestBody["item_per_page"] = this.state.pageSize;
    this.callSearchApi(requestBody);
  };

  callSearchApi = (requestBody) => {
    this.setState({
      cacheRequestBody: requestBody,
      loading: true,
      disable: true,
    });

    searchHistoryLogTier(requestBody).then((response) => {
      const { error } = response;
      let data = [];
      let { page_no } = requestBody;
      let pages = this.state.pages;
      let pageSize = this.state.pageSize;
      let isOpenModal = false;
      let modalMessage = "";
      let sessionTimeout = false;

      if (error) {
        const errorCode = error["errorCode"];
        sessionTimeout = errorCode === "401" || errorCode === "403";
        isOpenModal = true;
        modalMessage = error["errorMessage"];
      } else {
        const { content } = response.data;
        if (content.length === 0) {
          this.setState({
            data: [],
            loading: false,
            disable: false,
            page: 0,
            pages: 0,
            pageSize: pageSize,
            showPagination: false,
            notFound: { title: "" },
          });
        } else {
          const { totalElements } = response.data;
          data = content;
          pages = Math.ceil(totalElements / pageSize);
        }
      }

      this.setState({
        data: data,
        loading: false,
        disable: false,
        page: page_no - 1,
        pages: pages,
        pageSize: pageSize,
        showPagination: false,
        sessionTimeout: sessionTimeout,
        isOpenModal: isOpenModal,
        modalMessage: modalMessage,
      });
    });
  };

  prepareColumns = () => {
    return [
      {
        Header: "#",
        accessor: "index",
        width: 50,
        style: TEXT_CELL_STYLE,
        Cell: (props) => {
          const { index } = props;
          return index + 1 + this.state.page * this.state.pageSize;
        },
      },
      {
        Header: "Date Time",
        accessor: "dateTime",
        flexGrow: 1,
        maxWidth: 200,
        Cell: (cellInfo) => this.convertDateToString(cellInfo.value),
      },
      {
        Header: "Branch",
        accessor: "branch",
        style: { wordWrap: "break-word", whiteSpace: "pre-line" },
      },
      {
        Header: "Currency",
        accessor: "currencyUnit",
      },
      {
        Header: "New Value",
        accessor: "newValue",
        style: { wordWrap: "break-word", whiteSpace: "pre-line" },
      },
      {
        Header: "User Name",
        accessor: "creator",
        flexGrow: 1,
        maxWidth: 100,
      },
    ];
  };

  render() {
    const columns = this.prepareColumns();
    return (
      <div>
        <ModalNotFound
            message={"Tier history log not found."}
            isOpen={!!this.state.notFound}
            description={this.state.notFound?.description ?? ""}
            onRequestClose={() => this.setState({ notFound: null })}
        />
        <div className="card">
          <div className="card-header">
            <h5>History Log</h5>
          </div>
          <TierPricingHistorySearchForm
            onSubmit={this.fetchHistoryData}
            onClear={this.onClear}
            disable={this.state.disable}
          />
        </div>
        <div className="card mt-2">
          <div className="card-body">
            <div className="row">
              <div className="col-md-8 offset-md-2">
                <ReactTable
                  columns={columns}
                  data={this.state.data}
                  showPagination={this.state.showPagination}
                  showPaginationTop
                  page={this.state.page}
                  pages={this.state.pages}
                  pageSizeOptions={this.state.pageSizeOptions}
                  pageSize={this.state.pageSize}
                  onPageChange={this.onPageChange}
                  onPageSizeChange={this.onPageSizeChange}
                  loading={this.state.loading}
                  className="-highlight history-report"
                  manual
                />
              </div>
            </div>
          </div>
        </div>

          <ModalError
              isOpen={this.state.isOpenModal}
              onRequestClose={this.requestModalCloseHandler}
              message={this.state.modalMessage}
          />
        </div>
    );
  }
}
export default withTranslation()(TierPricingHistorySearch);
